<div class="terms-modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="terms-modal-container" role="dialog" aria-modal="true" aria-labelledby="consent-terms-title" (click)="$event.stopPropagation()">
    <div class="terms-modal-header">
      <div class="terms-modal-header-text">
        <h2 id="consent-terms-title" class="terms-modal-title">Terms &amp; Conditions: {{ shopName }}</h2>
        <p class="terms-modal-updated">Last updated: {{ lastUpdatedLabel }}</p>
      </div>
      <button type="button" class="terms-modal-close" (click)="onClose()" aria-label="Close">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M13 1L1 13M1 1L13 13" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <div class="terms-modal-body">
      <section class="terms-section">
        <h3 class="terms-section-title">1. SMS Terms</h3>
        <p class="terms-paragraph">
          By entering your phone number and tapping &ldquo;Get Coupon,&rdquo; you agree to receive text messages from
          {{ shopName }} as described below.
        </p>

        <h4 class="terms-subsection-title">1.1 What You&rsquo;ll Receive</h4>
        <p class="terms-paragraph">You agree to receive text messages, including:</p>
        <ul class="terms-list">
          <li>Your coupon</li>
          <li>Service and account updates</li>
          <li>Offers, promotions, and reminders</li>
        </ul>
        <p class="terms-paragraph">
          Messages may be sent via an automated system. Your consent is not required to make a purchase. Message
          frequency varies. Standard message and data rates may apply.
        </p>

        <h4 class="terms-subsection-title">1.2 Use of Your Information</h4>
        <p class="terms-paragraph">
          We collect your phone number and basic details needed to deliver your coupon and related services. We will:
        </p>
        <ul class="terms-list">
          <li>Not sell your personal information</li>
          <li>Share it only with service providers (like SMS and payment partners) to run this service</li>
          <li>Handle your data in line with our Privacy Policy and applicable laws</li>
        </ul>

        <h4 class="terms-subsection-title">1.3 Your Responsibility</h4>
        <p class="terms-paragraph">By submitting your number, you confirm:</p>
        <ul class="terms-list">
          <li>The number belongs to you</li>
          <li>You&rsquo;re authorized to receive messages on it</li>
        </ul>

        <h4 class="terms-subsection-title">1.4 Opt-Out &amp; Help</h4>
        <p class="terms-paragraph">
          Reply STOP to unsubscribe immediately. You will receive one final confirmation message and no further messages
          unless you opt back in. For help, reply HELP<span *ngIf="shopEmail"> or contact us at {{ shopEmail }}</span>.
        </p>

        <h4 class="terms-subsection-title">1.5 Carrier Disclaimer</h4>
        <p class="terms-paragraph">
          Supported carriers include AT&amp;T, T-Mobile, Verizon, and other major U.S. carriers. Carriers are not
          responsible for delayed or undelivered messages.
        </p>

        <h4 class="terms-subsection-title">1.6 Compliance</h4>
        <p class="terms-paragraph">
          {{ shopName }} follows applicable messaging laws, including the Telephone Consumer Protection Act (TCPA).
        </p>
      </section>

      <section class="terms-section">
        <h3 class="terms-section-title">2. Coupon Terms</h3>
        <ul class="terms-list">
          <li>Coupons are sent by SMS, usually within a few minutes</li>
          <li>Valid only at participating {{ shopName }} locations</li>
          <li>Must be used before the date in the message</li>
          <li>Cannot be combined with other offers unless stated</li>
          <li>One coupon per phone number unless specified</li>
          <li>{{ shopName }} may refuse or cancel coupons if misuse or fraud is suspected</li>
        </ul>
      </section>

      <section class="terms-section">
        <h3 class="terms-section-title">3. Membership Terms</h3>
        <p class="terms-paragraph">{{ shopName }} offers:</p>
        <ul class="terms-list">
          <li>Unlimited Wash Club</li>
          <li>Monthly Wash Pass</li>
        </ul>
        <p class="terms-paragraph">These terms apply to both.</p>

        <h4 class="terms-subsection-title">3.1 Billing &amp; Renewal</h4>
        <p class="terms-paragraph">
          Membership renews automatically every month. You will be charged at the start of every billing cycle.
        </p>

        <h4 class="terms-subsection-title">3.2 Cancellation</h4>
        <p class="terms-paragraph">
          You can cancel at any time. Your membership remains active until the end of the current billing period. No
          partial refunds for unused time. You will not be charged after cancellation.
        </p>

        <h4 class="terms-subsection-title">3.3 Vehicle Rules</h4>
        <p class="terms-paragraph">
          Membership applies to one registered vehicle only. A valid RFID tag must be attached. Membership cannot be
          shared or transferred.
        </p>

        <h4 class="terms-subsection-title">3.4 Program Changes</h4>
        <p class="terms-paragraph">{{ shopName }} may update membership features at any time.</p>
      </section>

      <section class="terms-section">
        <h3 class="terms-section-title">4. Changes to These Terms</h3>
        <p class="terms-paragraph">
          We may update these Terms from time to time. Updates will be posted with a new date. Continued use of the
          service means you accept the updated Terms.
        </p>
      </section>

      <section class="terms-section">
        <h3 class="terms-section-title">5. Contact</h3>
        <p class="terms-paragraph">Questions? Reach out:</p>
        <p class="terms-contact-block">
          <strong>{{ shopName }}</strong><br />
          <ng-container *ngIf="shopAddress">{{ shopAddress }}<br /></ng-container>
          <ng-container *ngIf="shopEmail">Email: {{ shopEmail }}<br /></ng-container>
          <ng-container *ngIf="shopContact">Phone: {{ shopContact }}</ng-container>
        </p>
      </section>
    </div>
  </div>
</div>
